// extracted by mini-css-extract-plugin
export default {"link":"CompletedForm_link__jEx2T","printLinkContainer":"CompletedForm_printLinkContainer__3hMMR"};